type ThingKey = string;

export type ViewportOptions = {
  x?: number;
  y?: number;
  zoom?: number;
};

type ViewportFn = (opts: ViewportOptions) => void;

const makeKey = (recipePoolId: string, thingId: string): ThingKey => `${recipePoolId}:${thingId}`;

const registry = new Map<ThingKey, ViewportFn>();

export const registerViewport = (recipePoolId: string, thingId: string, fn: ViewportFn): void => {
  registry.set(makeKey(recipePoolId, thingId), fn);
};

export const unregisterViewport = (recipePoolId: string, thingId: string): void => {
  registry.delete(makeKey(recipePoolId, thingId));
};

export const setViewport = (recipePoolId: string, thingId: string, opts: ViewportOptions): void => {
  const fn = registry.get(makeKey(recipePoolId, thingId));
  if (!fn) { return; }
  // Defer to next frame to ensure DOM/layout after state updates
  requestAnimationFrame(() => fn(opts));
};

const canvasViewportRegistry = { registerViewport, unregisterViewport, setViewport };
export default canvasViewportRegistry;


